import React from 'react';
import { PERSONAL_INFO, SOCIAL_LINKS } from '../../data/constants';
import { IconGithub, IconLinkedin, IconMail, IconTwitter, IconMapPin } from '../ui/Icons';
import './Footer.css';

const ICON_MAP: Record<string, React.ReactNode> = {
  github:   <IconGithub   size={17} />,
  linkedin: <IconLinkedin size={17} />,
  email:    <IconMail     size={17} />,
  twitter:  <IconTwitter  size={17} />,
};

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <span className="footer__logo-mark">SD</span>
              <span className="footer__logo-name">Supratick Dey</span>
            </div>
            <p className="footer__bio">
              Solutions Architect specialising in production GenAI, Lakehouse data platforms,
              and cloud infrastructure for enterprise clients across Asia.
            </p>
            <div className="footer__socials">
              {SOCIAL_LINKS.filter(l => ICON_MAP[l.icon]).map(link => (
                <a key={link.platform} href={link.url} target="_blank" rel="noopener noreferrer"
                  className="footer__social" aria-label={link.label}>
                  {ICON_MAP[link.icon]}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-heading">Navigation</h4>
            <ul className="footer__links">
              {['home','about','skills','portfolio','services','certifications','contact'].map(id => (
                <li key={id}><a href={`#${id}`} className="footer__link">{id.charAt(0).toUpperCase() + id.slice(1)}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-heading">Expertise</h4>
            <ul className="footer__links">
              {['GenAI & RAG Pipelines','BigQuery · Snowflake Lakehouse','Kubernetes & Cloud Infra','LLM Fine-tuning','Apache Spark & Airflow','Golang · Python · Java'].map(e => (
                <li key={e} className="footer__expertise">{e}</li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-heading">Contact</h4>
            <div className="footer__contact-items">
              <a href={`mailto:${PERSONAL_INFO.email}`} className="footer__contact-item">
                <IconMail size={15} /> {PERSONAL_INFO.email}
              </a>
              <span className="footer__contact-item">
                <IconMapPin size={15} /> {PERSONAL_INFO.location}
              </span>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copy">&copy; {year} Supratick Dey. All rights reserved.</p>
          <p className="footer__sub">Solutions Architect · GenAI · Lakehouse · Cloud</p>
        </div>
      </div>
    </footer>
  );
};
